export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9412.08e0c46b.jpg";